import fabianPic from "@/public/images/artists/fabian.png";
import { Artist } from "@/types/types";

export const fabian = {
  id: "172",
  name: "Fabian",
  image: fabianPic,
  description: `Fabian's voice is crafted for modern pop, offering a high register with smooth androgynous tonal characteristics. Whether shaping bright lead vocals or intricate harmonies, Fabian adapts effortlessly to elevate your production.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ffabian-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Pop", "RnB", "Dance"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 52,
        high: 70,
      },
      sweetSpot: 60,
    },
  },
} as const satisfies Artist;
